import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { env } from '@/shared/config/env';
import type { Lang } from '@/shared/domain/types';

export interface LangState {
  current: Lang;
}

const langSlice = createSlice({
  name: 'lang',
  initialState: { current: env.defaultLang } as LangState,
  reducers: {
    setLang(state, a: PayloadAction<Lang>) {
      state.current = a.payload;
    },
  },
});

export const { setLang } = langSlice.actions;
export const langReducer = langSlice.reducer;
